<template>
<div id="reset">
  <v-container id="login" fluid tag="section" style=" margin-top:100px; ">
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4 lg4>

        <v-row justify="center">

          <v-slide-y-transition appear>
            <base-material-card color="primary" light max-width="100%" width="400" class="px-5 py-3">
              <template v-slot:heading>
                <div class="text-center">
                  Solicitud de Cambio de Contraseña
                </div>
              </template>

              <template v-if="!isValid" class="elevation-5 pa-4">
                <v-card-text>
                  <div class="layout column align-center">
                    <img src="/static/logo.png" alt="SkyTicketPOS" style="height:70px" />
                    <h1 class="flex my-4 primary--text"></h1>
                  </div>
                  <br />
                  <h5 class="text-center error--text">¡SOLICITUD NO VÁLIDA!</h5>
                  <br />
                  <br />
                  <v-alert :value="true" icon="info" color="info" class="white--text">
                    <span style="text-color:white">La solicitud a la que intenta acceder no es válida o ya caducó,
                      intente generar una nueva o comuníquese con el administrador de
                      ser necesario.</span>
                  </v-alert>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn small @click="loginurl">
                    <v-icon color="primary">keyboard_arrow_left</v-icon> Ir a inicio
                  </v-btn>
                </v-card-actions>
              </template>

              <template v-if="isValid" class="elevation-5 pa-4">

                <div class="layout column align-center">
                  <img src="/static/logo.png" alt="SkyTicketPOS" style="height:70px" />
                  <h1 class="flex my-4 primary--text"></h1>
                </div>
                <v-form ref="form">
                  <v-container grid-list-md text-xs-center @keyup.enter="actualizar()">
                    <v-text-field :append-icon="iconpass" name="pass_new" :rules="[rules.required, rules.password]" label="Ingresar Nueva Contraseña" :type="passwordFieldType" @click:append="mostrarPass" v-model="model.pass_new"></v-text-field>
                    <v-text-field :append-icon="iconpass" name="pass_confirm" :rules="[rules.required, rules.password, valida_iguales]" label="Confirmar Nueva Contraseña" :type="passwordFieldType" @click:append="mostrarPass"
                      v-model="model.pass_confirm"></v-text-field>
                  </v-container>
                </v-form>

                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn block small v-bind:disabled="model.pass_confirm === '' ||
                                      model.pass_confirm != model.pass_new
                                  " @click="actualizar" :loading="loading">Actualizar</v-btn>
                </v-card-actions>
              </template>

            </base-material-card>
          </v-slide-y-transition>
        </v-row>
      </v-flex>

    </v-layout>
  </v-container>
</div>
</template>

<script>
import axios from "axios";

export default {
  /*beforeMount: function() {
    this.rules = this.$rules;
    this.validar();
  },*/
  created: async function() {
    this.URL = this.$hostname + "carta_porte/general/";
    this.rules = this.$rules;
    this.id_solicitud = this.$route.params.id;
    await this.validar();
    console.log("todo listo")
  },
  data: () => ({
    fab: false,
    loading: false,
    passwordFieldType: "password",
    iconpass: "fa-eye",
    isValid: false,
    id_usuario: "",
    id_solicitud: "",
    rules: {},
    model: {
      pass_new: "",
      pass_confirm: ""
    }
  }),
  computed: {
    toolbarColor() {
      return this.$vuetify.options.extra.mainNav;
    },
    computeLogo() {
      return "/static/logo_blanco.png";
    }
  },
  methods: {
    valida_iguales: function() {
      if (this.model.pass_new === this.model.pass_confirm) {
        return true;
      } else {
        return "Las contraseñas no coinciden";
      }
    },
    loginurl() {
      this.$router.push("/");
    },
    mostrarPass: function(evt) {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
      this.iconpass =
        this.passwordFieldType === "password" ? "fa-eye" : "fa-eye-slash";
    },
    login() {
      this.$root.$dialogLoader.show('Espere un momento por favor..');
      setTimeout(() => {
        this.$router.push("/dashboard");
      }, 1000);
    },
    validar: async function() {
      this.$root.$dialogLoader.show('Espere un momento por favor..');
      var self = this;
      var params = {
        TableName: "solicitud_password",
        Key: {
          uuid: self.id_solicitud,
        },
      };
      await self.$axios.post(self.URL + "valida_token/", params).then(async res => {
        console.log(res.data.estatus)
          if(res.data.estatus == 0) {
              self.isValid = true;
              self.id_usuario = res.data.uuid_usuario;
          } else {
            console.log("no es valido")
            self.isValid = false;
          }
      }).catch(err => {
        console.log("en el error")
          self.isValid = false;
          self.$root.$dialogLoader.hide();
      }).then(x => {
        self.$root.$dialogLoader.hide();
      });
    },
    actualizar() {
      if (this.$refs.form.validate()) {
        this.$root.$dialogLoader.show('Espere un momento por favor..');

        this.model.pass_new = this.$crypto.SHA256(this.model.pass_new);

        var self = this;
        var params = {
          "uuid": self.id_usuario,
          "password": self.model.pass_new
        };

        this.$axios.post(this.$hostname + "carta_porte/administracion/update_usuario/", params)
          .then(res => {
            var params2 = {
              TableName: "solicitud_password",
              Key: {
                uuid: self.id_solicitud,
              },
              AttributeUpdates: {
                'estatus': {
                  Action: "PUT",
                  Value: 1,
                },
              },
            };
            self.$axios.post(self.URL + "update_token/", params2).then(res2 => {
              
            });
            self.$router.push("/", () => {
              self.$swal({
                type: "success",
                title: "¡Operación Exitosa!",
                text: "La contraseña se actualizó correctamente.",
                footer: "",
              });
            });
          })
          .catch(err => {
            self.$swal({
              type: "error",
              title: "Error",
              text: "Ocurrió un cambiar la contraseña.",
              footer: "",
            });
          }).then(() => {
            self.$root.$dialogLoader.hide();
          });
      }

    }
  }
};
</script>
<style scoped lang="css">
#reset {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>
